<template>
  <div v-if="total != 0">
    <Chart :donut-center-render="'donutCenterRenderer'">
      <template v-slot:donutCenterRenderer>
        <span
          ><h5>Total: {{ total }}</h5>
        </span>
      </template>
      <ChartTooltip :render="'renderTooltip'">
        <template v-slot:renderTooltip="{ props }">
          <div v-if="props">
            {{ props.point.value }}
          </div>
        </template>
      </ChartTooltip>
      <ChartSeries>
        <ChartSeriesItem
          :type="'donut'"
          :data-items="items"
          :category-field="'label'"
          :field="selectedProduct == 'VTS' ? 'totalVehicle' : 'totalEmployees'"
          :holeSize="60"
        >
          <ChartSeriesLabels
            :background="'none'"
            :font="'10'"
            :content="labelEmployeesContent"
          />
        </ChartSeriesItem>
      </ChartSeries>
      <ChartLegend :visible="true" />
    </Chart>
  </div>
  <div v-else class="d-flex justify-content-center align-items-center w-100 h-100">
    <h4>No Data Available</h4>
  </div>
</template>
<script>
import {
  Chart,
  ChartLegend,
  ChartSeries,
  ChartSeriesItem,
  ChartSeriesLabels,
  ChartTooltip,
} from "@progress/kendo-vue-charts";
import { createNamespacedHelpers } from "vuex";
const {
  mapGetters,
  mapActions,
  mapMutations,
  mapState,
} = createNamespacedHelpers("dashboard");

const labelEmployeesContent = (e) => e.value;

export default {
  components: {
    Chart,
    ChartLegend,
    ChartSeries,
    ChartSeriesItem,
    ChartSeriesLabels,
    ChartTooltip,
  },
  data: function() {
    return {
      labelEmployeesContent: labelEmployeesContent,
    };
  },
  props: {
    selectedProduct: String,
    dashboardData: {},
    selectedTenant: {},
  },
  computed: {
    dataItems() {
      if (this.selectedProduct == "VTS") {
        let vehicleData = this.$store.getters["dashboard/getTenantVehicles"];
        const data = vehicleData.filter(
          (vcl) => vcl.tenantId === this.selectedTenant
        );
          let TotalVehicle = data.length > 0 ? data[0].totalVehicles : 0;
          let activeVehiclesCount = data.length > 0 ? data[0].activeVehicles : 0;
          let inActiveVehiclesCount = data.length > 0 ? data[0].inActiveVehicles : 0;
          return [
            { label: "Total Vehicle", totalVehicle: TotalVehicle },
            { label: "Active", totalVehicle: activeVehiclesCount },
            { label: "Inactive", totalVehicle: inActiveVehiclesCount },
          ];

      } else {
        const data = this.dashboardData.find(
          (vcl) => vcl.tenantId === this.selectedTenant
        );
        if (data?.employees && data?.employees.length > 0) {
          let totalEmployees = data.employees.reduce((total, item) => {
            return total + item.isActive + item.isInActive;
          }, 0);
          let activeEmployees = data.employees.reduce((total, item) => {
            return total + item.isActive;
          }, 0);
          let inactiveEmployees = data.employees.reduce((total, item) => {
            return total + item.isInActive;
          }, 0);
          return [
            { label: "Total Employees", totalEmployees: totalEmployees },
            { label: "Active", totalEmployees: activeEmployees },
            { label: "Inactive", totalEmployees: inactiveEmployees },
          ];
        } else {
          return [
            { label: "Total Employees", totalEmployees: 0 },
            { label: "Active", totalEmployees: 0 },
            { label: "Inactive", totalEmployees: 0 },
          ];
        }
      }
    },
    items() {
      let items = [...this.dataItems];
      items.shift();
      return items;
    },
    total() {
      if (this.selectedProduct == "VTS") {
        return this.dataItems[0]?.totalVehicle
          ? this.dataItems[0].totalVehicle
          : 0;
      } else {
        return this.dataItems[0]?.totalEmployees
          ? this.dataItems[0].totalEmployees
          : 0;
      }
    },
  },
  methods: {
    ...mapState(["currentYear"]),
    ...mapActions(["getTenantDetailsOnProductName"]),
    ...mapMutations(["getNoOfVehicles", "getNoOfEmployees"]),
    ...mapGetters(["getTenantVehicles", "getTenantEmployees"]),
  },
  mounted() {
    // this.getDataOnLoad();
  },
};
</script>
